import React, { useEffect, useState } from "react";
import { url } from "../../utils/const";

let sessionRequest;
const requestCurrentSession = () => {
  if (!sessionRequest) {
    const sessionId = localStorage.getItem("sessionId");
    sessionRequest = fetch(`${url}/session`, {
      credentials: "include",
      cache: "no-store",
      headers: sessionId ? { authorization: sessionId } : undefined,
    })
      .then(async (response) => {
        if (!response.ok) return { authenticated: false };
        return response.json();
      })
      .catch(() => ({ authenticated: null }));
  }
  return sessionRequest;
};

const SessionBootstrap = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;

    requestCurrentSession()
      .then((data) => {
        if (data?.authenticated === false) {
          ["sessionId", "user", "code", "name", "level", "point", "customer"]
            .forEach((key) => localStorage.removeItem(key));
          return;
        }
        // Un fallo temporal de red no invalida ni elimina una sesión local.
        if (data?.authenticated !== true || !data.user) return;
        const user = data.user;
        if (user.sessionId) localStorage.setItem("sessionId", user.sessionId);
        if (user.user || user.code) localStorage.setItem("user", user.user || user.code);
        if (user.code) localStorage.setItem("code", user.code);
        if (user.name) localStorage.setItem("name", user.name);
        if (user.level) localStorage.setItem("level", user.level);
        if (user.point) localStorage.setItem("point", user.point);
        if (user.company) localStorage.setItem("customer", user.company);
      })
      .finally(() => {
        if (active) setReady(true);
      });

    return () => {
      active = false;
    };
  }, []);

  return ready ? children : null;
};

export default SessionBootstrap;
